module.exports = __webpack_public_path__ + "static/img/1.b9ee55ab.jpg";